import React from 'react';
import PropTypes from 'prop-types';
import {
    Card,
    CardActions,
    CardText,
} from 'material-ui/Card';
import {
    GridList,
    GridTile,
} from 'material-ui/GridList';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import PublicMaster from '../master/Public';
import {
    loginService,
    Utils,
} from '../../services';

const styles = {
    loginCard: {
        textAlign: 'center',
        width: '100%',
        border: 'solid 2px #c0c0c0',
        borderRadius: 16,
    },
    buttonActionContent: {
        padding: 16,
    },
};

class Login extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loginEmail: true,

            emailFoiEnviado: false,
            email: '',
            usuarioEmail: '',
            usuario: '',
            senha: '',
        };
    }

    async componentWillMount() {
        if (Utils.getUsuarioEstaLogado()) {
            this.props.history.push('/');
        } else {
            this.csrfToken = (await loginService.loginForm()).token;
        }
    }

    async onLoginPorEmail(event) {
        event.preventDefault();
        const {
            usuarioEmail,
            usuario,
            senha,
            loginEmail,
        } = this.state;
        const request = { _csrf: this.csrfToken };
        if (loginEmail) {
            request.usuario = usuarioEmail;
            request.senha = null;
        } else {
            request.usuario = usuario;
            request.senha = senha;
        }

        try {
            const response = await loginService.loginPeloEmail(request);
            if (loginEmail && response.emailEnviado) {
                this.setState({ emailFoiEnviado: true, email: response.email });
            } else if (response.success) {
                window.location = '/';
            } else {
                Utils.showToast('Erro desconhecido ao realizar o login.');
            }
        } catch (error) {
            Utils.showToast(error.message);
        }
    }

    async onLoginPeloLogos(event) {
        event.preventDefault();
        const {
            usuario,
            senha,
            loginEmail,
        } = this.state;
        const request = { _csrf: this.csrfToken };
        request.usuario = usuario;
        request.senha = senha;

        try {
            const response = await loginService.loginPeloLogos(request);
            if (loginEmail && response.emailEnviado) {
                this.setState({ emailFoiEnviado: true, email: response.email });
            } else if (response.success) {
                window.location = '/';
            } else {
                Utils.showToast('Erro desconhecido ao realizar o login.');
            }
        } catch (error) {
            Utils.showToast(error.message);
        }
    }

    reenviarEmail() {
        this.setState({ emailFoiEnviado: false, email: '' });
    }

    render() {
        const {
            emailFoiEnviado,
            email,
            usuarioEmail,
            usuario,
            senha,
        } = this.state;

        return (
            <PublicMaster title="Login" {...this.props}>
                <div className="padding-content">
                    <GridList cols={1} style={{ textAlign: 'center' }}>
                        <GridTile>
                            <h2>Use uma das opções abaixo para fazer login:</h2>
                        </GridTile>
                    </GridList>
                    <GridList cols={2} cellHeight="auto" padding={16}>
                        <GridTile style={styles.loginCard}>
                            <h3>Login por e-mail </h3>
                            <Card style={{ margin: 8 }}>
                                {
                                    emailFoiEnviado ?
                                        <div>
                                            <CardText>
                                                <h4>Agora acesse o e-mail <b>{email}</b> e clique no link que foi enviado.</h4>
                                            </CardText>
                                            <CardActions style={styles.buttonActionContent}>
                                                <RaisedButton label="Reenviar e-mail" primary onClick={() => this.reenviarEmail()} />
                                            </CardActions>
                                        </div> :
                                        <form onSubmit={e => this.onLoginPorEmail(e)}>
                                            <CardText>
                                                <TextField
                                                    ref={(ref) => { this.usuarioRef = ref; }}
                                                    floatingLabelText="E-mail ou CPF"
                                                    autoFocus
                                                    required
                                                    fullWidth
                                                    errorText={usuarioEmail ? '' : 'Campo obrigatório'}
                                                    onChange={e => this.setState({ usuarioEmail: e.target.value })}
                                                    value={usuarioEmail}
                                                />
                                            </CardText>
                                            <CardActions key={1} style={styles.buttonActionContent}>
                                                <RaisedButton label="Entrar" primary type="submit" />
                                            </CardActions>
                                        </form>
                                }
                            </Card>
                        </GridTile>
                        <GridTile style={styles.loginCard}>
                            <h3>Login pelo usuário da SETREM</h3>
                            <h5>Somente para avaliadores e coordenadores.</h5>
                            <Card style={{ margin: 8 }}>
                                <form onSubmit={e => this.onLoginPeloLogos(e)}>
                                    <CardText>
                                        <TextField
                                            ref={(ref) => { this.usuarioRef = ref; }}
                                            autoFocus
                                            floatingLabelText="Usuário da SETREM"
                                            required
                                            fullWidth
                                            errorText={usuario ? '' : 'Campo obrigatório'}
                                            onChange={e => this.setState({ usuario: e.target.value })}
                                            value={usuario}
                                        />
                                        <TextField
                                            ref={(ref) => { this.senhaRef = ref; }}
                                            floatingLabelText="Senha"
                                            type="password"
                                            required
                                            fullWidth
                                            errorText={senha ? '' : 'Campo obrigatório'}
                                            onChange={e => this.setState({ senha: e.target.value })}
                                            value={senha}
                                        />
                                    </CardText>
                                    <CardActions key={1} style={styles.buttonActionContent}>
                                        <RaisedButton label="Entrar" primary type="submit" />
                                    </CardActions>
                                </form>
                            </Card>
                        </GridTile>
                    </GridList>
                </div>
            </PublicMaster>
        );
    }
}

Login.propTypes = {
    history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
};

export default Login;
